import axiosInstance from "@/api/axiosInstance";
import { FetchProductSearchResultsRequest, FetchProductSearchResultsResponse } from "./types";

export const fetchProductSearchResults = async (
  params: FetchProductSearchResultsRequest,
): Promise<FetchProductSearchResultsResponse> => {
  const response = await axiosInstance.get<FetchProductSearchResultsResponse>(
    "/api/private/products/search",
    { params },
  );
  return response.data;
};
